
export interface ColorFilterData {
  id: string;
  prompt_name: string;
  priority: number;
  tags: string[];
}

export const COLOR_FILTERS: ColorFilterData[] = [
  {
    id: "color-red",
    prompt_name: "Red Tones",
    priority: 100,
    tags: ["warm", "passionate"]
  },
  {
    id: "color-blue",
    prompt_name: "Blue Hues",
    priority: 90,
    tags: ["cool", "calming"]
  },
  {
    id: "color-green",
    prompt_name: "Green Colors",
    priority: 80,
    tags: ["natural", "fresh"]
  },
  {
    id: "color-purple",
    prompt_name: "Purple Shades",
    priority: 70,
    tags: ["mystical", "royal"]
  },
  {
    id: "color-orange",
    prompt_name: "Orange Tones",
    priority: 60,
    tags: ["energetic", "warm"]
  },
  {
    id: "color-yellow",
    prompt_name: "Yellow Accents",
    priority: 50,
    tags: ["bright", "cheerful"]
  },
  {
    id: "color-pink",
    prompt_name: "Pink Tones",
    priority: 40,
    tags: ["soft", "romantic"]
  },
  {
    id: "color-black",
    prompt_name: "Black Contrast",
    priority: 30,
    tags: ["dramatic", "bold"]
  },
  {
    id: "color-white",
    prompt_name: "White Highlights",
    priority: 20,
    tags: ["clean", "pure"]
  },
  {
    id: "color-gold",
    prompt_name: "Golden Tones",
    priority: 10,
    tags: ["luxury", "metallic"]
  }
];
